import { makeStyles, createStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props: { flowTemplate: string; displayHeader: boolean; backgroundColor?: string }) =>
  makeStyles(() =>
    createStyles({
      routerOuterBox: {
        flex: '1 1 0%',
        background: props.backgroundColor || 'rgb(239, 239, 239)',
        color: 'rgb(42, 42, 42)',
        padding: props.flowTemplate === 'fair' && !props.displayHeader ? '0' : '22px 0px'
      },
      routerContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 0%',
        boxSizing: 'content-box',
        margin: '0px auto',
        padding: props.flowTemplate === 'fair' && !props.displayHeader ? '0' : '0px 20px',
        maxWidth: '1910px',
        width: 'auto',
        height: '100%'
      },
      routeContainerBox: {
        background: 'transparent',
        padding: props.flowTemplate === 'fair' && !props.displayHeader ? '0' : '0px 56px',
        flex: '1 1 0%'
      }
    })
  );
